import { render, staticRenderFns } from "./WordpressMcp.vue?vue&type=template&id=68825dce&scoped=true"
import script from "./WordpressMcp.vue?vue&type=script&lang=js"
export * from "./WordpressMcp.vue?vue&type=script&lang=js"
import style0 from "./WordpressMcp.vue?vue&type=style&index=0&id=68825dce&prod&lang=scss&scoped=true"
import style1 from "./WordpressMcp.vue?vue&type=style&index=1&id=68825dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68825dce",
  null
  
)

export default component.exports